<template>
  <div class="domain">
    <DomainTree v-if="$route.path === '/basicdata/domainsetting'" @isCollapse-treedata="isCollapseTreedata" @addcheck-treedata="getTreeCheckData" :checkDomainId="parentId" :orgData="orgData" :orgTreeData="orgTreeData" :oneNodeArr="oneNodeArr"></DomainTree>
    <div v-if="$route.path === '/basicdata/domainsetting'" class="right" :style="styleRight">
      <div class="operation">
        <div class="operationBtn">
          <el-dropdown trigger="click">
            <el-button :disabled="delDisabled">{{$t('LanguageLib.BATCH_SET')}}</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :title="$t('LanguageLib.DELETE')" @click.native.prevent="delDomainData">{{$t('LanguageLib.DELETE')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.TurnIntoShop')" @click.native.prevent="TransferShop">{{$t('LanguageLib.TurnIntoShop')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.Rebinding')" @click.native.prevent="Rebinding">{{$t('LanguageLib.Rebinding')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="addOrg" style="margin-left: 10px;">{{$t('LanguageLib.ADD_TO')}}</el-button>
          <el-dropdown trigger="click" style="margin-left: 10px;">
            <el-button type="primary" style="margin-left: 0;">{{$t('LanguageLib.ImportOrExport')}}</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :title="$t('LanguageLib.DOWNLOAD_TEMPLATE')" @click.native.prevent="downExcal(1)">{{$t('LanguageLib.DOWNLOAD_TEMPLATE')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.IMPORT_ORGANIZATION')">
                <el-upload
                  class="upload"
                  name="files"
                  :data="formData"
                  :action="uploadApi"
                  :headers="headers()"
                  :on-preview="handlePreview"
                  :before-upload="beforeUpload"
                  :on-error="onError"
                  :on-success="(file, response) => {onSuccess(file, response, 21000)}"
                  :show-file-list="false"
                  accept=".xlsx, .xls">
                  <el-button :plain="true" style="padding: 0px;border: none;color: #666;">{{$t('LanguageLib.IMPORT_ORGANIZATION')}}</el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.EXPORT_EXCEL')" @click.native.prevent="exportExcal">{{$t('LanguageLib.EXPORT_EXCEL')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.BINDING_QY_DEPARTMENT_DOWNLOAD')" @click.native.prevent="downExcal(28)">{{$t('LanguageLib.BINDING_QY_DEPARTMENT_DOWNLOAD')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.IMPORT_ORGANIZATION')">
                <el-upload
                  class="upload"
                  name="files"
                  :data="formData"
                  :action="uploadApi"
                  :headers="headers()"
                  :on-preview="handlePreview"
                  :before-upload="beforeUpload"
                  :on-error="onError"
                  :on-success="(file, response) => {onSuccess(file, response, 31000)}"
                  :show-file-list="false"
                  accept=".xlsx, .xls">
                  <el-button :plain="true" style="padding: 0px;border: none;color: #666;">{{$t('LanguageLib.BINDING_QY_DEPARTMENT')}}</el-button>
                </el-upload>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="operationSearch">
          <i @click="drawerOpen" style="cursor: pointer;" class="iconfont shaixuan" :class="{'shaixuan1' : shaixuan}">&#xe624;</i>
          <span v-show="isSearch" style="color:#666;font-size:14px;">{{$t('LanguageLib.SearchedOut')}}<span class="colorG">{{ pageTotal }} &nbsp;</span>{{$t('LanguageLib.Results')}}</span>
          <i v-show="isSearch" @click="clearSearchData" class="el-icon-close" style="margin:0 10px 0 10px;color:#666;font-size:14px;cursor: pointer;"></i>
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="searchText"
            @keyup.enter.native="searchDomainList"
          >
          </el-input>
        </div>
      </div>
      <div class="tableParent">
        <el-table
          empty-text=" "
          :data="tableData"
          stripe
          @selection-change="selectionChange"
          @sort-change='sortChange'
          :default-sort="defaultSort"
          ref="table"
          style="width: auto;"
          v-loading="loading"
          height="100%">
          <el-table-column
            type="selection"
            min-width="45">
          </el-table-column>
          <el-table-column
            prop="sortNo"
            :label="$t('LanguageLib.SERIAL_NUMBER')"
            sortable="custom"
            min-width="160">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="sortNo">{{scope.row.sortNo}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="sortNo">{{scope.row.sortNo}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="domainName"
            :label="$t('LanguageLib.NAME_OF_ASSOCIATION')"
            sortable="custom"
            min-width="180">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <ww-open-data slot="content" v-if="scope.row.domainName.slice(0, 3) === 'wx|' && JSON.parse($commonfun.localStorage.getitem('qyuser'))" type="departmentName" :openid="scope.row.domainName.slice(3)"></ww-open-data>
                <ww-open-data ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" v-if="scope.row.domainName.slice(0, 3) === 'wx|' && JSON.parse($commonfun.localStorage.getitem('qyuser'))" type="departmentName" :openid="scope.row.domainName.slice(3)"></ww-open-data>
                <span slot="content" type="departmentName" v-if="scope.row.domainName.slice(0, 3) !== 'wx|' || !JSON.parse($commonfun.localStorage.getitem('qyuser'))">{{scope.row.domainName}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="departmentName" v-if="scope.row.domainName.slice(0, 3) !== 'wx|' || !JSON.parse($commonfun.localStorage.getitem('qyuser'))">{{scope.row.domainName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="domainTypeName"
            :label="$t('LanguageLib.ORGANIZATION_TYPE')"
            sortable="custom"
            min-width="180">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="domainTypeName">{{scope.row.domainTypeName}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="domainTypeName">{{scope.row.domainTypeName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('LanguageLib.Is_Enterprise_Micro_Synchronization')"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="fromQy">{{$commonfun.isQySynchronization(scope.row.fromQy)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="fromQy">{{$commonfun.isQySynchronization(scope.row.fromQy)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="authStatus"
            :label="$t('LanguageLib.QW_BIND_STATUS')"
            sortable="custom"
            min-width="270">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="authStatus">{{$commonfun.authStatus(scope.row.authStatus)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="authStatus">{{$commonfun.authStatus(scope.row.authStatus)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateDate"
            :label="$t('LanguageLib.LAST_UPDATED')"
            min-width="180"
            sortable="custom">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="updateDate">{{ $commonfun.formatDate(scope.row.updateDate, '1') }}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="updateDate">{{ $commonfun.formatDate(scope.row.updateDate, '1') }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
           <el-table-column
            prop="description"
            :label="$t('LanguageLib.REMARK2')"
            min-width="230"
            sortable="custom">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="description">{{scope.row.description}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="description">{{scope.row.description}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            style="right: 10px;"
            :label="$t('LanguageLib.Operation')"
            min-width="130">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="editOrg(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.Edit')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60c;</i>
              </el-button>
              <el-button
                v-if="!scope.row.canTranslate"
                @click.native.prevent="noTranslate(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.TurnIntoShop')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#ccc;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe604;</i>
              </el-button>
              <el-button
                v-if="scope.row.canTranslate && scope.row.translateOper == 1"
                @click.native.prevent="deleteRow(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.TurnIntoShop')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe604;</i>
              </el-button>
              <el-button
                v-if="scope.row.canTranslate && scope.row.translateOper == 2"
                @click.native.prevent="returnOrg(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.RETURN_FOR_ORG')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe601;</i>
              </el-button>
              <el-button
                v-if="scope.row.authStatus === 1 && !scope.row.fromQy"
                @click.native.prevent="rebindingItem(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.Rebinding')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe618;</i>
              </el-button>
              <el-button
                v-if="scope.row.authStatus !== 1 || scope.row.fromQy"
                @click.native.prevent="rebindingItemError(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.Rebinding')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#ccc;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe618;</i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
    <el-drawer
      v-if="$route.path === '/basicdata/domainsetting'"
      :visible.sync="drawer"
      :show-close="true"
      :modal="false"
      :wrapperClosable="false"
      size="420px"
      :with-header="false">
      <div style="overflow: hidden">
        <p style="float: left;" class="drawerTitle">{{$t('LanguageLib.Filter')}}</p>
        <el-button @click="drawerClose" style="float: right;padding: 4px 0 0 0;font-size: 18px;color: #4d4d4d;" type="text"><i class="el-icon-close"></i></el-button>
      </div>
      <p class="drawerText">{{$t('LanguageLib.NAME_OF_ASSOCIATION')}}</p>
      <el-input
        :placeholder="$t('LanguageLib.PleaseEnter')"
        v-model="searchOrgName"
      >
      </el-input>
      <p class="drawerText">{{$t('LanguageLib.ORGANIZATION_TYPE')}}</p>
      <el-select style="width: 100%;" v-model="checkedSelectData" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
        <el-option
          v-for="item in searchOrgTypeList"
          :key="item.id"
          :label="item.domainTypeName"
          :value="item.id">
        </el-option>
      </el-select>
      <p class="drawerText">{{$t('LanguageLib.REMARK2')}}</p>
      <el-input
        type="textarea"
        :rows="3"
        resize="none"
        v-model="searchDescContent"
      >
      </el-input>
      <div style="position: absolute;bottom: 68px;right: 20px;">
        <el-button @click="resetSearchData" style="height: 30px;padding: 7px 20px;" class="resetBtn">{{$t('LanguageLib.RESET')}}</el-button>
        <el-button @click="searchOrgList" style="height: 30px;padding: 7px 20px;" type="primary" class="searchBtn">{{$t('LanguageLib.SEARCH_FOR')}}</el-button>
      </div>
    </el-drawer>
    <!--导出excal-->
    <el-dialog :title="$t('LanguageLib.SELECT_EXPORT_FIELD')" :visible.sync="dialogExcal" class="ExcalDialog dialogList" :before-close="closeDialog" :close-on-click-modal="false">
      <div class="checkFiled">
        <el-form>
          <div class="contentTop">
              <el-radio v-model="allField" :label="item.label" v-for="item in FieldData" :key="item.label" @change="handleCheckAllChange">{{item.name}}</el-radio >
          </div>
          <div class="basicsField">
            <h4>{{$t('LanguageLib.BASE_FIELD')}}</h4>
            <div class="basicsFieldChild">
              <el-checkbox-group v-model="checkedFields">
                <el-checkbox v-for="item in Fields" :label="item" :key="item" :disabled="allField == '2'">{{item}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="customField">
            <h4>{{$t('LanguageLib.CUSTOM_FIELD')}}</h4>
          </div>
        </el-form>
      </div>
      <div class="showFiled">
        <p style="color: #999999;">{{$t('LanguageLib.CURRENT_SELECT_FIELD')}}</p>
        <ul>
          <li v-for="item in checkedFields" :key="item"><span>{{item}}</span><i class="el-icon-close" @click="delField(item)" v-if="allField == '1'"></i></li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()" :loading="loadingSave">{{$t('LanguageLib.DETERMINE')}}</el-button>
      </div>
    </el-dialog>
    <router-view v-if="$route.path !== '/basicdata/domainsetting'"></router-view>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
import DomainTree from '@/components/DomainTree.vue'
import baseUrl from '@/utils/base'
export default {
  name: 'domainsetting',
  components: { DomainTree },
  props: {
    msg: String
  },
  data () {
    return {
      uploadApi: baseUrl.uploadApi, // 上传地址
      loading: true, // loading状态
      isSearch: false, // 是否为搜索状态
      dialogExcal: false, // 是否显示导出excal弹框
      orgTreeData: [], // 组织树数据
      orgData: [], // 组织树源数据
      oneNodeArr: [], // 一级组织下的数据
      tableData: [], // 列表数据
      pageTotal: 0, // 数据总数
      shaixuan: false, // 漏斗图是否高亮
      formData: { path: 'images' },
      getOrgDataListFun: (pageIndex, pageSize, parentId, search, sort, sortOrder, typeId, remark, domainName) => {
        console.log('调用列表接口')
        this.loading = true
        // 请求列表接口数据
        if (parentId === '') {
          parentId = null
        }
        if (typeId === '') {
          typeId = null
        }
        basicdataApi.getOrgDataList('post', '/sysdomain/domainlist', { pageIndex, pageSize, parentId, search, sort, sortOrder, typeId, remark, domainName })
          .then(res => {
            this.tableData = res.data.data
            this.pageTotal = res.data.pageTotal
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数
      searchText: '', // 列表搜索关键词
      parentId: '', // 列表请求parentId
      currentPage: 1, // 默认显示第1页数据
      pageSize: 20, // 默认每页显示20条数据
      sort: 'updateDate', // 排序字段
      sortOrder: 'desc', // 排序方式逆序：desc正序asc
      delDisabled: true, // 删除按钮默认禁用
      selectDomainData: [], // 选中的组织数据
      selectDomainObj: [], // 选中的组织数据对象
      drawer: false, // 抽屉框默认收起
      searchOrgName: '', // 抽屉框组织名称
      searchDescContent: '', // 抽屉框备注内容
      searchOrgTypeList: [], // 抽屉框组织类型列表
      checkedSelectData: '', // 抽屉框组织类型选中
      styleRight: 'width: 80%;margin-left: 20%', // right默认宽度
      defaultSort: { prop: 'updateDate', order: 'descending' }, // 默认排序
      prevSort: 'descending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'updateDate', // 记录前一次的prop值
      updataRouteQuery: () => {
        console.log('状态机保存')
        const query = this.$router.history.current.query
        const path = this.$router.history.current.path
        const newQuery = JSON.parse(JSON.stringify(query))
        newQuery.currentPage = this.currentPage
        newQuery.pageSize = this.pageSize
        newQuery.checkDomainId = this.parentId
        newQuery.searchText = this.$commonfun.encodeUrl(this.searchText)
        newQuery.sort = this.sort
        newQuery.sortOrder = this.sortOrder
        newQuery.checkedSelectData = this.checkedSelectData
        newQuery.searchDescContent = this.$commonfun.encodeUrl(this.searchDescContent)
        newQuery.searchOrgName = this.$commonfun.encodeUrl(this.searchOrgName)
        newQuery.NoRefresh = true
        this.$router.push({ path, query: newQuery })
      },
      FileData: {
        FileName: '', // 文件名称
        FilePath: '', // 文件地址
        EnumImportType: 21000 // 导入类型 21000为组织导入
      }, // 文件导入参数
      loadingSave: false, // 保存按钮加loding
      allField: '2', // 导出excal-所有字段
      isIndeterminate: false, // 导出excal-所有字段勾选框状态
      FieldData: [
        // {
        //   name: this.$t('LanguageLib.SELECT_VIEW'),
        //   label: '1'
        // },
        {
          name: this.$t('LanguageLib.EXPORT_FOLLOW_UP'),
          label: '2'
        }
      ], // 导出查看/导出跟进
      checkedFields: [this.$t('LanguageLib.NAME_OF_ASSOCIATION'), this.$t('LanguageLib.PARENT_ORGANIZATION_NAME'), this.$t('LanguageLib.ORGANIZATION_TYPE'), this.$t('LanguageLib.Is_Enterprise_Micro_Synchronization'), this.$t('LanguageLib.REMARK2')], // 已选中的字段
      Fields: [this.$t('LanguageLib.NAME_OF_ASSOCIATION'), this.$t('LanguageLib.PARENT_ORGANIZATION_NAME'), this.$t('LanguageLib.ORGANIZATION_TYPE'), this.$t('LanguageLib.Is_Enterprise_Micro_Synchronization'), this.$t('LanguageLib.REMARK2')]
    }
  },
  created () {
    console.log('调用created')
    if (this.$route.query.currentPage) {
      console.log('调用读取状态')
      this.currentPage = this.$route.query.currentPage * 1
      this.pageSize = this.$route.query.pageSize * 1
      this.parentId = this.$route.query.checkDomainId
      this.searchText = this.$commonfun.decodeUrl(this.$route.query.searchText)
      this.sort = this.$route.query.sort
      this.sortOrder = this.$route.query.sortOrder
      this.checkedSelectData = this.$route.query.checkedSelectData
      this.searchDescContent = this.$commonfun.decodeUrl(this.$route.query.searchDescContent)
      this.searchOrgName = this.$commonfun.decodeUrl(this.$route.query.searchOrgName)
      if (this.sortOrder === 'asc') {
        this.defaultSort = { prop: this.sort, order: 'ascending' }
        this.prevSort = 'ascending'
      } else {
        this.defaultSort = { prop: this.sort, order: 'descending' }
        this.prevSort = 'descending'
      }
      this.prevProp = this.sort
    }
    if (this.searchOrgName === '' && this.searchDescContent === '' && this.checkedSelectData === '') {
      this.isSearch = false
      this.shaixuan = false
    } else {
      this.isSearch = true
      this.shaixuan = true
    }
    // 获取组织树列表
    basicdataApi.gettreelist('get', '/sysdomain/domainTree')
      .then(res => {
        console.log('调用树接口')
        this.orgData = res.data
        if (res.data.length > 0 && this.$route.query.fromPath === undefined) {
          // 'nextTick()' 下次dom更新时触发回调函数
          // 默认点击
          this.$nextTick().then(() => {
            if (document.querySelector('.el-tree-node__content')) {
              document.querySelector('.el-tree-node__content').click()
            }
          })
        }
        this.orgTreeData = this.$commonfun.toTree(res.data, 'childDomainTrees', 'id', 'parentDomainId')
        this.oneNodeArr.push(this.orgTreeData[0].id)
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
    basicdataApi.DelOrgTypeDataList('get', '/sysdomain/domainType', {
      pageIndex: 1,
      pageSize: 2147483647
    })
      .then(res => {
        this.searchOrgTypeList = res.data
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
    // 默认获取所有数据
    this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
  },
  methods: {
    // 树组件传过来的数据
    getTreeCheckData (data) {
      this.$commonfun.console.log(data)
      this.parentId = data.id
      // 请求列表接口数据
      this.currentPage = 1
      this.pageSize = 20
      this.updataRouteQuery()
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
    },
    // 显示隐藏组织树
    isCollapseTreedata (data) {
      this.$commonfun.console.log(data)
      if (data === true) {
        this.styleRight = 'width: calc(100% - 25px);margin-left: 25px;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      } else {
        this.styleRight = 'width: 80%;margin-left: 20%;transition-property: width , margin-left; transition-duration:.28s , .28s;'
      }
    },
    // 列表排序
    sortChange (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.sortOrder = 'asc'
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.prevSort = 'descending'
          this.sortOrder = 'desc'
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.table.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.sortOrder = column.column.order === 'descending' ? 'desc' : 'asc'
      }
      this.sort = column.prop
      // 请求列表接口数据
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
    },
    // 页数改变
    handleSizeChange (val) {
      this.pageSize = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
    },
    // 每页条数改变
    handleCurrentChange (val) {
      this.currentPage = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
    },
    // 列表模糊搜索
    searchDomainList () {
      this.currentPage = 1
      this.updataRouteQuery()
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
    },
    // 删除组织数据
    delDomainData () {
      this.$commonfun.confirm(this.$t('LanguageLib.DeleteSelectOrganization'), this.$t('LanguageLib.DELETE_ORGANIZATION'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          basicdataApi.DelOrgDataList('post', '/sysdomain/deleted', this.selectDomainData)
            .then(res => {
              this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
              })
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 重新同步
    Rebinding () {
      this.$commonfun.confirm(this.$t('LanguageLib.Rebinding_MSG1'), this.$t('LanguageLib.Rebinding'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          basicdataApi.AgainSync('post', '/SysDomain/againSync', this.selectDomainData)
            .then(res => {
              console.log(res)
              this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
              if (res.data.successCount === 0) {
                this.$message({
                  type: 'error',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_OPERATION_FAIL'), this.$t('LanguageLib.Rebinding'))
                })
              } else if (res.data.failCount === 0) {
                this.$message({
                  type: 'success',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_OPERATION_SUCCESS'), this.$t('LanguageLib.Rebinding'))
                })
              } else {
                this.$message({
                  type: 'info',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_ORGANIZATION_TO_STORE_INFO'), res.data.successCount, res.data.failCount, this.$t('LanguageLib.Rebinding'), this.$t('LanguageLib.Rebinding'))
                })
              }
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
        })
    },
    // 转为店铺
    TransferShop () {
      var data = []
      var date = new Date()
      var year = date.getFullYear().toString().substr(2, 2)
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hour = date.getHours()
      var minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      var time = year + month + day + hour + minute + second
      for (var i in this.selectDomainObj) {
        var item = this.selectDomainObj[i]
        var storeCode = (time * 1) + i * 1
        var obj = {
          domainId: item.id,
          parentDomainId: item.parentDomainId,
          storeCode: storeCode + '',
          storeName: item.domainName,
          storeLang: this.$commonfun.localStorage.getitem('OwnerLanguage') * 1,
          storeStartTime: '08:00:00',
          storeEndTime: '22:00:00',
          isClose: false,
          manageType: 0
        }
        data.push(obj)
      }
      this.$commonfun.confirm(this.$t('LanguageLib.SELECTED_ORGANIZATION_TO_STORE'), this.$t('LanguageLib.TurnIntoShop'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          basicdataApi.TranslateIntoStoreBatch('post', '/store/translateIntoStoreBatch', data)
            .then(res => {
              this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
              if (res.data.successCount === 0) {
                this.$message({
                  type: 'error',
                  message: this.$t('LanguageLib.SELECTED_ORGANIZATION_TO_STORE_FAIL')
                })
              } else if (res.data.failCount === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.SELECTED_ORGANIZATION_TO_STORE_SUCCESS')
                })
              } else {
                this.$message({
                  type: 'info',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_ORGANIZATION_TO_STORE_INFO'), res.data.successCount, res.data.failCount, this.$t('LanguageLib.ORGANIZATION_TO_STORE'), this.$t('LanguageLib.TurnIntoShop'))
                })
              }
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
        })
    },
    // 组织选择
    selectionChange (selection) {
      this.selectDomainData = []
      this.selectDomainObj = []
      for (let i = 0; i < selection.length; i++) {
        this.selectDomainData.push(selection[i].id)
        this.selectDomainObj.push(selection[i])
      }
      if (this.selectDomainData.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    },
    // 过滤点击
    drawerOpen () {
      this.drawer = true
      this.shaixuan = true
    },
    // 过滤关闭
    drawerClose () {
      this.drawer = false
      this.shaixuan = false
    },
    // 点击搜索
    searchOrgList () {
      this.drawer = false
      this.isSearch = true
      this.currentPage = 1
      this.updataRouteQuery()
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
    },
    // 清空搜索数据
    resetSearchData () {
      this.searchOrgName = ''
      this.searchDescContent = ''
      this.checkedSelectData = ''
    },
    // 清除搜索状态
    clearSearchData () {
      this.shaixuan = false
      this.isSearch = false
      this.searchOrgName = ''
      this.searchDescContent = ''
      this.checkedSelectData = ''
      this.currentPage = 1
      this.updataRouteQuery()
      this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
    },
    // 点击添加组织数据
    addOrg () {
      this.$router.push('/basicdata/domainsetting/addorg?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&checkDomainId=' + this.parentId + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder + '&checkedSelectData=' + this.checkedSelectData + '&searchDescContent=' + this.$commonfun.encodeUrl(this.searchDescContent) + '&searchOrgName=' + this.$commonfun.encodeUrl(this.searchOrgName) + '&type=add&fromQy=false')
    },
    // 编辑组织
    editOrg (data, index, tableData) {
      this.$router.push('/basicdata/domainsetting/addorg?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&checkDomainId=' + this.parentId + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder + '&checkedSelectData=' + this.checkedSelectData + '&searchDescContent=' + this.$commonfun.encodeUrl(this.searchDescContent) + '&searchOrgName=' + this.$commonfun.encodeUrl(this.searchOrgName) + '&type=edit&fromQy=' + data.fromQy + '&id=' + data.id)
    },
    // 无法转为店铺
    noTranslate () {
      this.$message({
        type: 'info',
        message: this.$t('LanguageLib.THE_ORG_NO_ALLOW_TURN_SHOP1')
      })
    },
    // 组织转店铺
    deleteRow (data, index, tableData) {
      this.$router.push('/basicdata/domainsetting/addstore?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&checkDomainId=' + this.parentId + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder + '&checkedSelectData=' + this.checkedSelectData + '&searchDescContent=' + this.$commonfun.encodeUrl(this.searchDescContent) + '&searchOrgName=' + this.$commonfun.encodeUrl(this.searchOrgName) + '&type=add&fromQy=' + data.fromQy + '&id=' + data.id)
    },
    // 店铺转组织
    returnOrg (data, index, tableData) {
      this.$commonfun.confirm(this.$t('LanguageLib.IS_RETURN_ORG'), this.$t('LanguageLib.TurnIntoOrg'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          basicdataApi.restoredomain('post', '/store/restoredomain', {
            domainId: data.id
          })
            .then(res => {
              this.$commonfun.console.log(res)
              this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.SUCCESSFULLY_REDUCTION')
              })
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
        })
    },
    // 单个重新同步提示
    rebindingItemError (data, index, tableData) {
      this.$message({
        type: 'info',
        message: this.$commonfun.stringFormat(this.$t('LanguageLib.Rebinding_MSG2'), this.$t('LanguageLib.ORGANIZATION1'))
      })
    },
    // 单个重新同步
    rebindingItem (data, index, tableData) {
      this.$commonfun.confirm(this.$t('LanguageLib.Rebinding_MSG1'), this.$t('LanguageLib.Rebinding'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          basicdataApi.AgainSync('post', '/SysDomain/againSync', [data.id])
            .then(res => {
              this.$commonfun.console.log(res)
              this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
              this.$message({
                type: 'success',
                message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_OPERATION_SUCCESS'), this.$t('LanguageLib.Rebinding'))
              })
            })
            .catch(err => {
              this.$commonfun.console.log(err)
              this.$message({
                type: 'error',
                message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_OPERATION_FAIL'), this.$t('LanguageLib.Rebinding'))
              })
            })
        }).catch(() => {
        })
    },
    // 导出excal
    exportExcal () {
      this.dialogExcal = true
    },
    // 导出跟进字段全部选中
    handleCheckAllChange () {
      this.checkedFields = JSON.parse(JSON.stringify(this.Fields))
    },
    // 取消选中字段
    delField (type) {
      for (let i = 0; i < this.checkedFields.length; i++) {
        if (type === this.checkedFields[i]) {
          this.checkedFields.splice(i, 1)
        }
      }
    },
    // 关闭对话框
    closeDialog () {
      this.dialogExcal = false
    },
    // 下载导入模板
    downExcal (type) {
      basicdataApi.sysdomainExport('get', '/basicdata/exceltemplate?template=' + type)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.DOWNLOAD_SUCCESSFUL')
          })
          this.dialogExcal = false
          var filename = ''
          type === 1 ? filename = 'Domain' + '_' + this.$commonfun.localStorage.getitem('lang') + '.xlsx' : filename = 'WxOrgBind' + '_' + this.$commonfun.localStorage.getitem('lang') + '.xlsx'
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(new Blob([res.data]))
          a.href = url
          a.download = filename
          a.click()
          window.URL.revokeObjectURL(url)
          this.loadingSave = false
        })
        .catch(err => {
          this.loadingSave = false
          this.$commonfun.console.log(err)
        })
    },
    // 导入模板
    headers () {
      return { token: this.$commonfun.localStorage.getitem('token'), lang: this.$commonfun.localStorage.getitem('lang') }
    },
    handlePreview (file) {
    },
    beforeUpload (file) {
      const type = file.name.slice(file.name.lastIndexOf('.'), file.name.length)
      if (type !== '.xlsx' && type !== '.xls' && type !== '.XLSX' && type !== '.XLS') {
        this.$message.success(this.$t('LanguageLib.FILE_FORMAT_ERROR_PLEASE_UPLOAD_EXCAL'))
        return false
      }
    },
    // 上传失败
    onError (file) {
      this.$message.success(this.$t('LanguageLib.UPLOAD_FAILED'))
    },
    // 上传成功
    onSuccess (file, response, EnumImportType) {
      this.FileData.FilePath = file[0]
      this.FileData.FileName = response.name
      this.FileData.EnumImportType = EnumImportType
      basicdataApi.importinfoImport('post', '/importinfo/create', this.FileData)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.FILE_ALREADY_UPLOAD_YOU_CAN_VIEW_IMPORT_ASSISTANT')
          })
          this.getOrgDataListFun(this.currentPage, this.pageSize, this.parentId, this.searchText, this.sort, this.sortOrder, this.checkedSelectData, this.searchDescContent, this.searchOrgName)
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 导出Excal
    submit () {
      this.loadingSave = true
      if (this.$commonfun.localStorage.getitem('qyuser') === 'false') {
        // 非企微登录扫码导出
        basicdataApi.sysdomainExport('post', '/sysdomain/Export', {
          parentId: this.parentId === '' ? null : this.parentId,
          sort: this.sort,
          sortOrder: this.sortOrder,
          search: this.searchText,
          typeId: this.checkedSelectData === '' ? null : this.checkedSelectData,
          remark: this.searchDescContent,
          domainName: this.searchOrgName
        })
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('LanguageLib.EXPORT_SUCCESSFULLY')
            })
            this.dialogExcal = false
            // 获取当前日期
            var today = new Date()
            var Month = today.getMonth() + 1
            var day = today.getDate()
            if (Month < 10) {
              Month = '0' + Month
            }
            if (day < 10) {
              day = '0' + day
            }
            var hours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
            var minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
            var second = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
            var milliSeconds = today.getMilliseconds()
            var currentDay = today.getFullYear() + '' + Month + '' + day + '' + hours + '' + minute + '' + second + '' + milliSeconds
            var filename = 'Domain' + '_' + currentDay + '.xlsx'
            var a = document.createElement('a')
            var url = window.URL.createObjectURL(new Blob([res.data]))
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
            this.loadingSave = false
          })
          .catch(err => {
            this.loadingSave = false
            this.$commonfun.console.log(err)
          })
      } else {
        // 企微登录扫码导出
        basicdataApi.ExportWXTranslate('post', '/SysDomain/ExportWXTranslate', {
          parentId: this.parentId === '' ? null : this.parentId,
          sort: this.sort,
          sortOrder: this.sortOrder,
          search: this.searchText,
          typeId: this.checkedSelectData === '' ? null : this.checkedSelectData,
          remark: this.searchDescContent,
          domainName: this.searchOrgName
        })
          .then(res => {
            var time = 0
            var timeId = setInterval(() => {
              time++
              basicdataApi.GetWXTranslateURL('get', '/export/GetWXTranslateURL', {
                jobId: res.data.jobId
              })
                .then(result => {
                  if (result.data.url !== null) {
                    window.clearInterval(timeId)
                    this.$message({
                      type: 'success',
                      message: this.$t('LanguageLib.EXPORT_SUCCESSFULLY')
                    })
                    this.dialogExcal = false
                    // 获取当前日期
                    var today = new Date()
                    var Month = today.getMonth() + 1
                    var day = today.getDate()
                    if (Month < 10) {
                      Month = '0' + Month
                    }
                    if (day < 10) {
                      day = '0' + day
                    }
                    var hours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
                    var minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
                    var second = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
                    var milliSeconds = today.getMilliseconds()
                    var currentDay = today.getFullYear() + '' + Month + '' + day + '' + hours + '' + minute + '' + second + '' + milliSeconds
                    var filename = 'Domain' + '_' + currentDay + '.xlsx'
                    var a = document.createElement('a')
                    // var url = window.URL.createObjectURL(new Blob([result.data]))
                    a.href = result.data.url
                    a.download = filename
                    a.click()
                    window.URL.revokeObjectURL(result.data.url)
                    this.loadingSave = false
                  } else {
                    if (time === 5) {
                      window.clearInterval(timeId)
                      this.dialogExcal = false
                      this.loadingSave = false
                      this.$message({
                        type: 'error',
                        message: this.$t('LanguageLib.EXPORT_FAILED')
                      })
                    }
                  }
                })
                .catch(err => {
                  this.loadingSave = false
                  this.$commonfun.console.log(err)
                })
            }, 2000)
          })
          .catch(err => {
            this.loadingSave = false
            this.$commonfun.console.log(err)
          })
      }
    }
  }
}
</script>

<style lang="scss">
.domain{
  width:100%;
  height: 100%;
  ul {
    list-style-type: none;
    padding: 0;
  }
  .el-button--primary{
    background-color:#3BC6B9;
    color:#fff;
    border:none;
  }
  /*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #3BC6B9 !important;
    border-color: #3BC6B9 !important;
  }*/
  // 对于树组件配置特有的css
  .el-tree-node>.el-tree-node__children{
    overflow: unset;
  }
  .el-tree-node__content{
    height: 48px;
  }
  .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
    background-color: #F6F6F6;
  }
  // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>span:last-child{
  //   color: #3BC6B9 !important;
  // }
  // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>ww-open-data{
  //   color: #3BC6B9 !important;
  // }
  // 更改表格的滚动条样式
  .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
      width: 10px;
      height: 10px;
  }
  .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    background: #E1E1E1;
  }
  .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 5px;
    background: #fff;
  }
  // 抽屉组件样式修改
  .el-drawer.rtl{
    outline: none;
  }
  .el-drawer__wrapper{
    top: 172px;
    bottom: 18px;
    /*right: 20px;*/
  }
  section.el-drawer__body{
    padding: 20px;
    .el-input{
      margin-bottom: 15px;
    }
  }
  .el-drawer__container{
    outline: none;
  }
  .colorG{
    height:20px;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(59,198,185,1);
    line-height:20px;
  }
  .el-table .descending .sort-caret.descending{
    border-top-color: #3BC6B9;
  }
  .el-table .ascending .sort-caret.ascending{
    border-bottom-color: #3BC6B9;
  }
  .el-pager li.active{
    color: #3BC6B9;
  }
  .left{
    background: #fff;
    width: 20%;
    float:left;
    height: 100%;
    border-right: 1px solid #f2f2f2;
    .treeBox{
      height: calc( 100% - 50px );
      overflow: auto;
      width: 100%;
    }
    .fifter{
      padding: 10px 0 10px 6%;
      line-height: 30px;
    .el-input{
        width: 60%;
      }
      .el-button--text{
        margin-left: 2.5%;
        padding: 2% 0;
        width: 20%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .right{
    width: 80%;
    margin-left: 20%;
    height: 100%;
    .operation{
      background: #fff;
      height: 30px;
      padding: 10px 0 10px 20px;
      border-bottom: 1px solid #f2f2f2;
      border-top: 1px solid #f2f2f2;
      .operationBtn{
        width: auto;
        display: inline-block;
        float:left;
        position: relative;
        .BatchSetting{
          background: #fff;
          color: #666;
          position:absolute;
          left: 0;
          top: 30px;
          font-size: 14px;
          text-align:center;
          box-shadow:0px 3px 6px 0px rgba(0,0,0,0.2);
          border-radius:2px;
          z-index: 99;
          min-width: 100px;
          li{
            line-height: 30px;
            cursor: pointer;
            padding: 0 10px;
          }
        }
        .el-button{
          height: 30px;
          padding: 7px 20px;
        }
        .exportType{
          background: #fff;
          color: #666666;
          position:absolute;
          right: 0;
          top: 30px;
          min-width:100px;
          font-size: 14px;
          text-align:center;
          box-shadow:0px 3px 6px 0px rgba(0,0,0,0.2);
          border-radius:2px;
          z-index: 99;
          li{
            line-height: 30px;
            cursor: pointer;
            padding: 0 10px;
          }
          // .upload{
          //   position: absolute;
          //   top: 30px;
          //   width: 100%;
          //   opacity: 0;
          //   .el-upload{
          //     width: 100%;
          //     button{
          //       width: 100%;
          //     }
          //   }
          // }
        }
      }
      .operationSearch{
        float:right;
        padding-right: 51px;
        position: relative;
        .shaixuan{
          color: #999999;
          height: 15px;
          width: 15px;
          position: relative;
          top: 2px;
          margin-left: 10px;
          margin-right: 10px;
          font-weight: 600;
        }
        .shaixuan1{
          color: #3BC6B9;
        }
        .el-input{
          width: 160px;
          .el-input__inner{
            height: 30px;
            line-height: 30px;
            border-radius: 20px;
          }
        }
        .el-icon-search{
          line-height: 30px;
        }
      }
    }
    .tableParent{
      height: calc( 100% - 98px );
    }
    .el-pagination{
      padding: 8px 15px 5px;
      height: 35px;
      background: #fff;
    }
  }
  .drawerTitle{
    height:25px;
    font-size:18px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(77,77,77,1);
    line-height:25px;
    margin-bottom: 20px;
  }
  .drawerText{
    height:16px;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(77,77,77,1);
    line-height:16px;
    margin-bottom: 5px;
  }
  .cell{
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
}
.el-tooltip__popper.is-light{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border: 1px solid #E4E7ED;
  background-color: #fff;
  color: #000;
  .popper__arrow{
    border-top-color: #E4E7ED;
    border: #E4E7ED;
  }
  .popper__arrow::after{
    border-top-color: #fff;
  }
}
.el-button--default{
  border:1px solid #3BC6B9;
  color:#3BC6B9;
}
.el-button--primary{
  color:#fff;
}
.ExcalDialog{
  .el-dialog{
    width: 1000px !important;
    .el-dialog__body{
      height: 350px;
      overflow-y: auto;
    }
    .checkFiled{
      height: 100%;
      border-right: 1px solid #D8DCE6;
      width: calc(70% - 21px);
      padding-right: 20px;
      float: left;
      h4 {
        font-size: 14px;
        color: #999999;
        font-weight: normal;
        padding-bottom: 10px;
        border-bottom: 1px solid #D8DCE6;
        margin-bottom: 15px;
      }
      .contentTop{
        margin-bottom: 15px;
      }
      .el-checkbox{
        margin-bottom: 15px;
      }
    }
    .showFiled{
      width: calc(30% - 20px);
      float: left;
      padding-left: 20px;
      li{
        margin-top: 10px;
        position: relative;
        span{
          padding-right: 20px;
          display: block;
        }
        .el-icon-close{
          position: absolute;
          right: 0;
          top: 3px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
